
import { SubDomain } from "../../SubDomain.js";
import GpsDevice from "./GpsDevice.js";
import GpsDeviceMap from "./GpsDeviceMap.js";

export default class GpsDevicesDomain extends SubDomain {

  constructor(domain, storage) {
    super(domain, GpsDevice.MODEL_NAME);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }

  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new GpsDevice(this.domain, item);
      }
    }

    var device = new GpsDevice(this.domain);
    device.withId(objId);
    return device;
  }

  findByCompany(company) {
    var map = new GpsDeviceMap(this.domain);
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      let device = new GpsDevice(this.domain, item);
      if (device.company().id() === company.id()) {
        map.add(device);
      }
    }
    return map;
  }

  findByVehicle(vehicle) {
    return this.findByVehicleId(vehicle.id());
  }

  findByVehicleId(vehicleId) {
    var map = new GpsDeviceMap(this.domain);
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      let device = new GpsDevice(this.domain, item);
      if (device.vehicle().id() === vehicleId) {
        map.add(device);
      }
    }
    return map;
  }

  findByImei(imei) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      let device = new GpsDevice(this.domain, item);
      if (device.imei() === imei) {
        return device;
      }
    }
    return null;
  }
}
